import { Expose } from "class-transformer";

export class SetValuationCertificationDto {
  @Expose()
  valuationId: string;

  @Expose()
  certificationId?: string;
}
